/**
 * Maps service region names to their corresponding region codes for contextId
 * @param location - The service region name (e.g., 'northAmerica', 'europe')
 * @returns The corresponding region code (e.g., 'us', 'eu')
 */
export const mapServiceRegionToRegion = (location: string): string => {
  const regionMapping: Record<string, string> = {
    northAmerica: 'us',
    europe: 'eu',
    asia: 'ap',
    australia: 'ap-au',
    unitedKingdom: 'eu-gb',
  };
  return regionMapping[location] || location;
};
